import React from 'react';
import ConditionLayout from '../../ConditionLayout/ConditionLayout';
import { useConditionLayoutProduct } from '../hooks/useConditionLayoutProduct';

type ConditionLayoutProductContainerProps = { children: React.ReactNode };

const ConditionLayoutProductContainer = ({ children }: ConditionLayoutProductContainerProps) => {
	const { Else, Then, conditionIsTrue, mzShowThen } = useConditionLayoutProduct();

	return <ConditionLayout {...{ Else, Then, conditionIsTrue, mzShowThen }}>{children}</ConditionLayout>;
};

export default ConditionLayoutProductContainer;
